/**
 * 图片加载失败的处理工具类
 * 功能：设置默认图 + 禁用父级a标签的点击跳转
 */

// 全局默认图地址
import defalutImg from "@/assets/img/no-img-default.png";

/**
 * 处理图片加载失败的核心方法
 * @param {HTMLElement} imgElement - 触发错误的img DOM元素
 * @param {string} customImg - 可选：自定义默认图地址，优先级高于全局默认图
 */
export function handleImgLoadError(imgElement, customImg) {
  // 1. 防重复执行：标记图片已触发错误，避免默认图失效导致的无限onerror循环
  if (imgElement.dataset.errorTriggered) return;
  imgElement.dataset.errorTriggered = 'true';
  // 2. 确定最终的默认图地址（自定义图 > 全局默认图）
  const finalDefaultImg = customImg || defalutImg;
  // 3. 设置默认图
  imgElement.src = finalDefaultImg;
  // 4. 查找父级a标签并禁用点击（兼容所有浏览器，替代closest方法）
  let aTag = imgElement;
  while (aTag && aTag.tagName !== 'A') {
    aTag = aTag.parentElement;
  }

  if (aTag) {
    // 移除跳转属性，从根源阻止跳转
    aTag.removeAttribute('href');
    aTag.removeAttribute('target');
    // 禁用点击事件 + 视觉样式
    aTag.style.pointerEvents = 'none';
    aTag.style.cursor = 'not-allowed';
    aTag.style.opacity = '0.7';
  }
}

/**
 * 可选：重置图片状态（如需重新加载图片时使用）
 * @param {HTMLElement} imgElement - img DOM元素
 * @param {string} originalSrc - 图片原始地址
 */
export function resetImgStatus(imgElement, originalSrc) {
  // 清除错误标记
  delete imgElement.dataset.errorTriggered;
  // 恢复图片地址
  imgElement.src = originalSrc;
  // 恢复父级a标签
  let aTag = imgElement;
  while (aTag && aTag.tagName !== 'A') {
    aTag = aTag.parentElement;
  }
  if (aTag) {
    aTag.href = originalSrc;
    aTag.target = '_blank';
    aTag.style.pointerEvents = 'auto';
    aTag.style.cursor = 'pointer';
    aTag.style.opacity = '1';
  }
}



// WEBPACK FOOTER //
// ./src/utils/defaultImgHandler.js